// `avatar mcp-run <tool-id>` — hidden command from Chapter 13 roadmap.
// Wrapper used by ~/.claude.json entries: Avatar injects secrets from keychain
// then spawns the underlying MCP process with stdio piped to Claude Code.
import type { Command } from "commander";
import { notImplementedYet } from "../lib/not-implemented-stub.js";

export function registerMcpRunCommand(program: Command): void {
  program
    .command("mcp-run <tool-id>", { hidden: true })
    .description("[internal] Spawn MCP với secrets injected (M09)")
    .action(notImplementedYet("mcp-run", "Milestone 09"));
}
